import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Phone, MessageSquare, ArrowLeft } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { MaskedLines, FadeUp } from "../components/site/Motion";
import { usePageMeta, usePhone } from "../lib/content";

export default function ThankYou() {
  const phone = usePhone();
  usePageMeta("Thank You | Rivanta Labs", "We've received your information. The Rivanta Labs team will reach out soon.");
  return (
    <div className="noise relative isolate flex min-h-[100svh] flex-col overflow-hidden">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[700px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-electric/20 blur-[150px]" />
      <header className="container-x flex h-[68px] items-center"><Logo testId="ty-logo-link" /></header>
      <main className="container-x flex flex-1 flex-col items-center justify-center py-16 text-center" data-testid="thank-you-page">
        <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 14 }}
          className="grid h-16 w-16 place-items-center rounded-full bg-electric shadow-[0_0_60px_rgba(0,136,255,0.7)]">
          <Check className="h-8 w-8 text-white" />
        </motion.span>
        <MaskedLines lines={["Thanks! We've Received", "Your Information."]} delay={0.2}
          className="mt-10 text-[2.3rem] leading-[1.02] sm:text-6xl font-semibold tracking-[-0.04em] text-white" />
        <FadeUp delay={0.4}>
          <p className="mx-auto mt-6 max-w-xl text-base sm:text-lg text-slate-300">Our team will review your information and reach out using the contact details you provided.</p>
        </FadeUp>
        <FadeUp delay={0.55} className="mt-12 w-full max-w-md rounded-3xl glass p-7">
          <p className="text-lg font-semibold text-white">Need to Speak With Us?</p>
          <p className="mt-1 text-sm text-slate-400">Call or text:</p>
          <a href={`tel:${phone.tel}`} data-testid="ty-phone-link" className="mt-3 block text-3xl font-semibold tracking-tight text-white hover:text-cyan-300">{phone.display}</a>
          <div className="mt-5 grid grid-cols-2 gap-3">
            <a href={`tel:${phone.tel}`} data-testid="ty-call-btn" className="btn-primary !px-4"><Phone className="h-4 w-4" /> Call</a>
            <a href={`sms:${phone.tel}`} data-testid="ty-text-btn" className="btn-ghost !px-4"><MessageSquare className="h-4 w-4" /> Text</a>
          </div>
        </FadeUp>
        <Link to="/" data-testid="ty-home-link" className="mt-10 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back to home</Link>
      </main>
    </div>
  );
}
